
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.396 18.645h9.375l.852-1.063-.867-1.078H.396v-1.11h8.485l-1.164-1.367.508-.43 3.742 3.735v.5l-3.742 3.734-.508-.43 1.172-1.382H.396v-1.11z","fill":"currentColor"}}),_c('rect',{attrs:{"x":".682","y":"26.066","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    